<template>
  <v-app>

    <!-- Menu -->
    <v-navigation-drawer app clipped :color="darkMode?'':'blue-grey lighten-5'" v-model="drawer" v-if="user != null && $store.state.companyId">
      <v-list dense nav class="d-flex flex-column pb-0" height="100%">
        <template v-for="menuItem in menuItems">
          <v-list-group no-action :prepend-icon="menuItem.icon" v-model="menuItem.expanded">
            <template v-slot:activator>
              <v-list-item-content>{{ menuItem.name }}</v-list-item-content>
            </template>
            <template v-for="item in menuItem.submenu">
              <template v-if="item.submenu">
                  <v-menu offset-x>
                    <template v-slot:activator="{on}">
                      <v-list-item v-on="on">
                        <v-list-item-title class="text-body-2 font-weight-regular">{{item.name}}</v-list-item-title>
                        <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                      </v-list-item>
                    </template>
                    <v-list :color="darkMode?'grey darken-3':'blue-grey lighten-5'">
                      <template v-for="subItem in item.submenu">
                        <v-divider v-if="subItem.divider"/>
                        <v-list-item v-else :to="subItem.to" class="text-body-2">{{subItem.name}}</v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
              </template>
              <v-list-item v-else :to="item.to" class="text-body-2">{{item.name}}</v-list-item>
            </template>
          </v-list-group>
        </template>
        <v-divider/>
        <v-list-item v-if="permissions.includes('reports') && !$vuetify.breakpoint.mobile" :to="{name:'Reports'}"  @click="closeOpenGroups">
          <v-list-item-icon><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
          {{ $t('menu.reports') }}
        </v-list-item>

        <v-list-group no-action prepend-icon="mdi-pin" >
          <template v-slot:activator>
            <v-list-item-content>{{ $t('menu.bookmarks') }}</v-list-item-content>
          </template>
          <template v-for="favourite in myFavourites">
            <v-list-item :to="to(favourite)" class="text-body-2" :key="favourite.id">{{ favourite.name }}</v-list-item>
          </template>
          <v-list-item class="text-caption" @click="showEditFavourites()">
            <v-icon small class="mr-1">mdi-pencil</v-icon>Manage
          </v-list-item>
        </v-list-group>

        <div class="mt-auto">
          <v-list-item :to="{name:'Apps'}"  @click="closeOpenGroups">
            <v-list-item-icon><v-icon>mdi-widgets</v-icon></v-list-item-icon>
            <div>
              <v-badge color="red" dot inline :value="appsAlert">
                {{ $t('menu.apps') }} <!--<v-icon color="green" class="ml-1">mdi-new-box</v-icon>-->
              </v-badge>
            </div>
          </v-list-item>
          <v-list-item v-if="permissions.includes('config')" :to="{name:'Settings'}"  @click="closeOpenGroups">
            <v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
            {{ $t('menu.settings') }}
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app height="48" :color="darkMode?'blue darken-4':'blue darken-2'" dark clipped-left clipped-right v-if="user != null">
      <div class="d-flex align-center">
        <v-img src="@/assets/still-small.png" height="30" width="20" contain/>
        <div class="text-subtitle ml-4" v-if="!$vuetify.breakpoint.mobile">{{company.name}}</div>
        <v-tooltip bottom open-delay="1000">
          <template v-slot:activator="{on}">
            <v-app-bar-nav-icon @click.stop="drawer=!drawer" class="ml-2" v-on="on"/>
          </template>
          Toggle menu
        </v-tooltip>

        <v-menu bottom max-width="400" :open-on-click="false" :close-on-click="false" :close-on-content-click="false"
                content-class="tour-arrow tour-arrow-left purple white--text pt-6 px-4"
                nudge-bottom="5" nudge-left="10"
                :value="dashboardHint">
          <template v-slot:activator="{on:dashboard}">
            <v-tooltip bottom open-delay="1000" nudge-bottom="10">
              <template v-slot:activator="{on}">
                <v-btn icon :to="{name:'Dashboard'}" small class="ml-2" v-on="on"><v-icon>mdi-monitor-dashboard</v-icon></v-btn>
              </template>
              Show the dashboard
            </v-tooltip>
          </template>
          Press this button to take you back to your dashboard.
          <v-btn plain class="white--text mt-4 float-right" @click.stop="doneDashboardHint()">Okay</v-btn>
        </v-menu>

        <v-menu bottom max-width="400" :open-on-click="false" :close-on-click="false" :close-on-content-click="false"
                content-class="tour-arrow tour-arrow-left purple white--text pt-6 px-4"
                nudge-bottom="5" nudge-left="10"
                :value="workflowHint"
                 v-if="!$vuetify.breakpoint.mobile">
          <template v-slot:activator="{on:workflow}">
            <v-tooltip bottom open-delay="1000" nudge-bottom="10">
              <template v-slot:activator="{on}">
                <v-btn icon :to="{path:'/production/overview'}" small class="ml-2" v-on="on"><v-icon>mdi-cogs</v-icon></v-btn>
              </template>
              Workflow view
            </v-tooltip>
          </template>
          Clicking the workflow view button takes you to an overview of PŪRTRAK components.
          This shows you how production, inventory, sales and purchasing is related and
          serves as a menu for quick access.
          <div class="mt-4">(You can try this now)</div>
          <v-btn plain class="white--text mt-4 float-right" @click.stop="doneWorkflowHint()">Okay</v-btn>
        </v-menu>

        <planning-tasks-outstanding v-if="company.allowPlanning"/>
      </div>

      <v-spacer/>
      <setup :welcome="!!$store.getters.userSettings.welcome"
              v-if="company.status!=='Inactive' && (!$store.getters.doneSetup || !!$store.getters.userSettings.welcome)"/>
      <v-spacer/>
      <calculator/>

      <!-- Help -->
      <v-menu bottom max-width="400" :open-on-click="false" :close-on-click="false" :close-on-content-click="false"
              content-class="tour-arrow tour-arrow-right purple white--text pt-6 px-4"
              nudge-bottom="5" nudge-left="258"
              :value="helpHint">
        <template v-slot:activator="{on}">
          <v-btn icon @click="help=$route.meta.help;showHelp=!showHelp" v-on="on"><v-icon>mdi-help-circle</v-icon></v-btn>
        </template>
        Help is available at all times.
        <v-btn plain class="white--text mt-4 float-right" @click.stop="doneHelpHint()">Okay</v-btn>
      </v-menu>

      <!-- User menu -->
      <div style="position:relative">
        <v-menu offset-y v-model="userMenu">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="mr-1">
              <v-avatar color="blue lighten-1" size="36">{{user.name.substring(0,1)}}</v-avatar>
            </v-btn>
          </template>
          <v-card width="200">
            <v-list dense>
              <v-list-item :to="{name:'UserInfo'}"><v-list-item-title>Personal information</v-list-item-title></v-list-item>
              <v-list-item @click="userPassword()"><v-list-item-title>Change password</v-list-item-title></v-list-item>
              <v-list-item @click.stop="$vuetify.theme.dark=!$vuetify.theme.dark;saveDark()">
                <v-list-item-title>Dark mode</v-list-item-title>
                <v-list-item-action><v-icon small class="mr-1" v-if="$vuetify.theme.dark">mdi-check</v-icon></v-list-item-action>
              </v-list-item>
              <v-list-item @click="toggleLanguage">
                <v-list-item-title>{{ $root.$i18n.locale === 'en' ? 'Français' : 'English' }}</v-list-item-title>
              </v-list-item>
              <v-divider/>
              <v-list-item @click="versionSummary()"><v-list-item-title>Version summary</v-list-item-title></v-list-item>
              <v-list-item @click="about()"><v-list-item-title>About PŪRTRAK</v-list-item-title></v-list-item>
              <v-divider/>
              <template v-if="$store.state.companies.length>1 || (company.allowAudit && permissions.includes('audit'))">
                <v-menu :nudge-left="200">
                  <template v-slot:activator="{on}">
                    <v-list-item v-on="on">
                      <v-list-item-title>Tools</v-list-item-title>
                      <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
                    </v-list-item>
                  </template>
                  <v-list dense>
                    <v-list-item v-if="$store.state.companies.length>1" @click="showSwitch();userMenu=false"><v-list-item-title>Switch distillery</v-list-item-title></v-list-item>
                    <v-list-item :to="{name:'RecurringTransactions'}" v-if="company.allowRecurringTransactions && (permissions.includes('buying') || permissions.includes('selling'))" @click="userMenu=false"><v-list-item-title>Recurring transactions</v-list-item-title></v-list-item>
                    <v-list-item :to="{name:'Audit'}" v-if="company.allowAudit && permissions.includes('audit')" @click="userMenu=false"><v-list-item-title>Audit log</v-list-item-title></v-list-item>
                  </v-list>
                </v-menu>
                <v-divider/>
              </template>
              <v-list-item @click="$auth.logout();$store.commit('clearUser');$auth.login()"><v-list-item-title>Sign out</v-list-item-title></v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

    </v-app-bar>

    <v-main>
      <v-snackbar :timeout="10000" v-model="showError" :color="errorType" top>
        {{error.message}}
        <div v-if="hasErrorInfo" class="mt-2 text-center"><v-btn small text @click="errorInfo">More info</v-btn></div>
        <template v-slot:action="{attrs}">
          <v-btn plain v-bind="attrs" @click="showError=false;">Close</v-btn>
        </template>
      </v-snackbar>

      <v-snackbar :timeout="-1" color="error" :value="company && company.status==='Inactive'" top>
        {{company.v8 ? 'PLEASE USE https://app8.purtrak.com FOR THE LATEST VERSION' : 'Distillery is inactive'}}
        <template v-slot:action v-if="permissions.includes('config') && !company.v8">
          <v-btn plain :to="{name:'Settings',params:{initialTab:1}}">Account settings</v-btn>
        </template>
      </v-snackbar>

      <v-card min-height="100%" :disabled="company && company.status==='Inactive' && $route.name !== 'Settings'">
        <router-view @closeMenu="drawer = false" @help="help=$event;showHelp=true"/>
      </v-card>
    </v-main>

    <help v-model="showHelp" :help="help"/>

    <component :is="dialog" @done="dialog = null"/>

    <v-snackbar v-model="newVersion" top color="gray" timeout="-1">
      <div>PŪRTRAK has been updated!</div>
      <div>Click <strong>REFRESH</strong> to load the newest version.</div>
      <div class="text-right mt-3"><span class="mr-16 text-decoration-underline cursor-pointer" @click="versionSummary()">View changes</span><v-btn @click="reload()" color="primary">Refresh</v-btn></div>
    </v-snackbar>
  </v-app>
</template>

<style scoped>
.v-list-item {
  flex: 0;
}
</style>

<script>
import Calculator from '@/views/tools/Calculator'
import Favourites from '@/views/tools/Favourites'
import PlanningTasksOutstanding from '@/views/planning/tasks/PlanningTasksOutstanding'
import Setup from '@/views/login/Setup'
import Help from '@/components/Help'
import reports from '@/mixins/reports'

export default {
  name: 'App',
  mixins: [reports],
  components: {Setup,Calculator,Favourites,PlanningTasksOutstanding,Help},
  data() {
    return {
      drawer: true,
      showError: false,
      errorType: null,
      showHelp: false,
      help: null,
			dialog: null,
      favouritesPick: [],
      userMenu: false,
      menu: [
            {name:this.$t('menu.production'),icon:'mdi-cogs',permission:'production',expanded:false,
                     submenu:[{name:this.$t('menu.mashing'),to:{name:'ProductionMashing'}},
                              {name:this.$t('menu.wineFermenting'),to:{name:'ProductionWineFermenting'}},
                              {name:this.$t('menu.distilling'),to:{name:'ProductionDistilling'}},
                              {name:this.$t('menu.blending'),to:{name:'ProductionBlending'}},
                              {name:this.$t('menu.bottling'),to:{name:'ProductionBottling'}},
                              {name:this.$t('menu.packing'),to:{name:'ProductionPacking'}},
                              {name:this.$t('menu.assembly'),to:{name:'ProductionAssembly'}},
                              {name:this.$t('menu.recipes'),submenu:[
                                                    {name:this.$t('menu.mashBills'),to:{name:'ProductionMashingMashBills'}},
                                                    {name:this.$t('menu.processes'),to:{name:'ProductionDistillingProcesses'}},
                                                    {name:this.$t('menu.formulas'),to:{name:'ProductionBlendingFormulas'}},
                                                    ]}
                             ]},
            {name:this.$t('menu.equipment'),icon:'mdi-tools',permission:'production',expanded:false,
                     submenu:[{name:this.$t('menu.tanks'),to:{name:'EquipmentTanks'}},
                              {name:this.$t('menu.fermenters'),to:{name:'EquipmentFermenters'}},
                              {name:this.$t('menu.stills'),to:{name:'EquipmentStills'}},
                              {name:this.$t('menu.otherEquipment'),to:{name:'EquipmentOther'}},
                             ]},
            {name:this.$t('menu.inventory'),icon:'mdi-tag',permission:'inventory',expanded:false,
                     submenu:[{name:this.$t('menu.products'),to:{name:'InventoryProducts'}},
                              {name:this.$t('menu.bulkContainers'),to:{name:'InventoryBulkContainers'}},
                              {name:this.$t('menu.casks'),to:{name:'InventoryCasks'}},
                              {name:this.$t('menu.items'),to:{name:'InventoryItems'}},
                              {name:this.$t('menu.bundles'),to:{name:'InventoryBundles'}}
                             ]},
            {name:this.$t('menu.sales'),icon:'mdi-cart',permission:'selling',expanded:false,
                        submenu:[{name:this.$t('menu.salesOrders'),to:{name:'SalesSalesOrders'}},
                                 {name:this.$t('menu.shipments'),to:{name:'SalesShipments'}},
                                 {name:this.$t('menu.invoices'),to:{name:'SalesInvoices'}},
                                 {name:this.$t('menu.customers'),to:{name:'SalesCustomers'}},
                                 {name:this.$t('menu.more'),submenu:[
                                                        {name:this.$t('menu.estimates'),to:{name:'SalesEstimates'}},
                                                        {name:this.$t('menu.returns'),to:{name:'SalesReturns'}},
                                                        {divider:true},
                                                        {name:this.$t('menu.taxes'),to:{name:'SettingsTaxes'}},
                                                        {name:this.$t('menu.terms'),to:{name:'SettingsTerms'}},
                                                        {name:this.$t('menu.paymentMethods'),to:{name:'SettingsPaymentMethods'}},
                                                        {divider:true},
                                                        {name:this.$t('menu.salesReps'),to:{name:'SalesReps'}},
                                                        {name:this.$t('menu.zones'),to:{name:'ShipmentZones'}},
                                                       ]}
                             ]},
            {name:this.$t('menu.purchasing'),icon:'mdi-credit-card-settings',permission:'buying',expanded:false,
                        submenu:[{name:this.$t('menu.purchaseOrders'),to:{name:'PurchasingPurchaseOrders'}},
                                 {name:this.$t('menu.inventoryReceipts'),to:{name:'PurchasingInventoryReceipts'}},
                                 {name:this.$t('menu.suppliers'),to:{name:'PurchasingSuppliers'}},
                                 {name:this.$t('menu.more'),submenu:[
                                                        {name:this.$t('menu.taxes'),to:{name:'SettingsTaxes'}},
                                                        {name:this.$t('menu.paymentMethods'),to:{name:'SettingsPaymentMethods'}},
                                                       ]}
                                ]},
            {name:this.$t('menu.alcohol'),icon:'mdi-flask-empty',permission:'production',expanded:false,
                        submenu:[{name:this.$t('menu.spirits'),to:{path:'/spirits'}},
                                 {name:this.$t('menu.wine'),to:{path:'/wine'}},
                                 {name:this.$t('menu.nonExcise'),to:{path:'/nonexcises'}}
                                ]},
            ],
    }
  },
  computed: {
    contextShowHelp() {
      return this.$store.state.showHelp;
    },
    workflowHint() {
      return this.$store.getters.userSettings.workflowHint && this.$store.state.setupReminder && !this.$store.getters.userSettings.welcome;
    },
    dashboardHint() {
      return this.$store.getters.userSettings.dashboardHint;
    },
    helpHint() {
      return this.$store.getters.userSettings.helpHint;
    },
    newVersion() {
      return this.$store.state.newVersion;
    },
    company() {
      return this.$store.getters.company;
    },
    permissions() {
      return this.company.permissions;
    },
    appsAlert() {
      return this.$store.state.appsAlert;
    },
    myFavouriteNames() {
      if (!this.$store.getters.userSettings.favourites)
        this.$store.getters.userSettings.favourites = [];
      return this.$store.getters.userSettings.favourites;
    },
    menuItems() {
      const menuItems = this.menu.filter(app => this.permissions.includes(app.permission));
      if (this.company.allowPlanning && (this.permissions.includes('forecasting') || this.permissions.includes('scheduling'))) {
        const menuItem = {name:"Planning", icon:'mdi-calendar-month',expanded:false,submenu:[]};
        if (this.permissions.includes('forecasting'))
          menuItem.submenu.push({name:'Forecasting',to:{name:'PlanningForecasting'}});
        if (this.permissions.includes('scheduling')) {
          menuItem.submenu.push({name:'Scheduling',to:{name:'PlanningScheduling'}});
          menuItem.submenu.push({name:'Tasks',to:{name:'PlanningTasks',params:{showUsersRoles:'1'}}});
        }
        menuItems.push(menuItem);
      }
      return menuItems;
    },
    error() {
      return this.$store.state.error;
    },
    user() {
      return this.$store.state.user;
    },
    hasErrorInfo() {
      return ['Item','Product','Vessel'].includes(this.error?.info?.type);
    },
    myFavourites() {
      return this.myFavouriteNames.map(favourite => this.getFavourite(favourite)).filter(favourite => favourite);
    }
  },
  watch: {
    drawer() {
      this.$store.commit('setDrawer', this.drawer);
    },
    error() {
      this.errorType = this.error.type;
      this.showError = this.error.type != undefined;
      setTimeout(() => {this.error.type = null;}, 1000);    // Wait a sec before clearing type to prevent other messages
    },
    contextShowHelp() {
      if (this.contextShowHelp) {
        this.help = this.$store.state.help;
        this.showHelp = true;
        this.$store.commit('setShowHelp', false);
      }
    }
  },
  created() {
    this.$vuetify.theme.dark = localStorage.getItem('dark') == '1';

    if (this.permissions.includes('production')) {
      this.favouritesPick.push({name:'Production',id:'production',
                                      menu:[{name:'Mashing',icon:'mdi-cogs',id:'ProductionMashing'},
                                            {name:'Create mash',icon:'mdi-cogs',plus:true,id:'ProductionMashingEditNew'},
                                            {name:'Distilling',icon:'mdi-cogs',id:'ProductionDistilling'},
                                            {name:'Create distillation',icon:'mdi-cogs',plus:true,id:'ProductionDistillingEditNew'},
                                            {name:'Blending',icon:'mdi-cogs',id:'ProductionBlending'},
                                            {name:'Create blend',icon:'mdi-cogs',plus:true,id:'ProductionBlendingEditNew'},
                                            {name:'Bottling',icon:'mdi-cogs',id:'ProductionBottling'},
                                            {name:'Create bottling',icon:'mdi-cogs',plus:true,id:'ProductionBottlingEditNew'},
                                            {name:'Assembly',icon:'mdi-cogs',id:'ProductionAssembly'},
                                            {name:'Create assembly',icon:'mdi-cogs',plus:true,id:'ProductionAssemblyEditNew'}]});
      this.favouritesPick.push({name:'Equipment',id:'equipment',
                                      menu:[{name:'Tanks',icon:'mdi-tools',id:'EquipmentTanks'},
                                            {name:'Fermenters',icon:'mdi-tools',id:'EquipmentFermenters'},
                                            {name:'Stills',icon:'mdi-tools',id:'EquipmentStills'},
                                            {name:'Other equipment',icon:'mdi-tools',id:'EquipmentOther'}]});
    }
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Inventory',id:'inventory',
                                      menu:[{name:'Products',icon:'mdi-tag',id:'InventoryProducts'},
                                            {name:'Batch product move list',icon:'mdi-tag',id:'InventoryProductsBatchMove'},
                                            {name:'Create batch product move',icon:'mdi-tag',plus:true,id:'InventoryProductsBatchMoveEditNew'},
                                            {name:'Reconcile product inv',icon:'mdi-tag',plus:true,id:'InventoryProductsReconcile'},
                                            {name:'Bulk containers',icon:'mdi-tag',id:'InventoryBulkContainers'},
                                            {name:'Casks',icon:'mdi-tag',id:'InventoryCasks'},
                                            {name:'Items & services',icon:'mdi-tag',id:'InventoryItems'},
                                            {name:'Reconcile item inventory',icon:'mdi-tag',plus:true,id:'InventoryItemsReconcile'},
                                            {name:'Bundles',icon:'mdi-tag',id:'InventoryBundles'}]});
    if (this.permissions.includes('selling'))
      this.favouritesPick.push({name:'Sales',id:'sales',
                                      menu:[{name:'Estimates',icon:'mdi-cart',id:'SalesEstimates'},
                                            {name:'Create estimate',icon:'mdi-cart',id:'SalesEstimatesEditNew'},
                                            {name:'Sales orders',icon:'mdi-cart',id:'SalesSalesOrders'},
                                            {name:'Create sales order',icon:'mdi-cart',plus:true,id:'SalesSalesOrdersEditNew'},
                                            {name:'Shipments',icon:'mdi-cart',id:'SalesShipments'},
                                            {name:'Create shipment',icon:'mdi-cart',plus:true,id:'SalesShipmentsEditNew'},
                                            {name:'Invoices',icon:'mdi-cart',id:'SalesInvoices'},
                                            {name:'Create invoice',icon:'mdi-cart',plus:true,id:'SalesInvoicesEditNew'},
                                            {name:'Customers',icon:'mdi-cart',id:'SalesCustomers'},
                                            {name:'Sales representitives',icon:'mdi-cart',id:'SalesReps'},
                                            {name:'Returns',icon:'mdi-cart',id:'SalesReturns'}]});
    if (this.permissions.includes('buying'))
      this.favouritesPick.push({name:'Purchasing',id:'purchasing',
                                      menu:[{name:'Purchase orders',icon:'mdi-credit-card-settings',id:'PurchasingPurchaseOrders'},
                                            {name:'Create purchase order',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingPurchaseOrdersEditNew'},
                                            {name:'Inventory receipets',icon:'mdi-credit-card-settings',id:'PurchasingInventoryReceipts'},
                                            {name:'Create inv receipt',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingInventoryReceiptsEditNew'},
                                            {name:'Suppliers',icon:'mdi-credit-card-settings',id:'PurchasingSuppliers'}]});
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Alcohol',id:'alcohol',
                                      menu:[{name:'Spirits',icon:'mdi-flask-empty',id:'Spirits'},
                                            {name:'Wine',icon:'mdi-flask-empty',id:'Wine'},
                                            {name:'Non-excise',icon:'mdi-flask-empty',id:'AlcoholNonExcises'}]});
    if (this.permissions.includes('forecasting') || this.permissions.includes('scheduling')) {
      const menu = [];
      if (this.permissions.includes('forecasting'))
        menu.push({name:'Forecasting',icon:'mdi-calendar-month',id:'PlanningForecasting'});
      if (this.permissions.includes('scheduling'))
        menu.push({name:'Scheduling',icon:'mdi-calendar-month',id:'PlanningScheduling'});
      this.favouritesPick.push({name:'Planning',id:'planning', menu});
    }
    if (this.permissions.includes('reports')) {
      const menu = [];
      for (const category of this.reports) {
        if (menu.length)
          menu.push({divider:true});
        for (const report of category.reports)
          menu.push({name:report.shortName??report.name, id:`ReportsView:${report.to}`, icon:'mdi-file-document-outline'});
      }
      this.favouritesPick.push({name:'Reports',id:'reports',menu});
    }
  },
  methods: {
    saveDark() {
      localStorage.setItem('dark', this.$vuetify.theme.dark ? 1 : 0)
    },
    doneWorkflowHint() {
      delete this.$store.getters.userSettings.workflowHint;
      this.$store.getters.userSettings.dashboardHint = true;
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    },
    doneDashboardHint() {
      delete this.$store.getters.userSettings.dashboardHint;
      this.$store.getters.userSettings.helpHint = true;
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    },
    doneHelpHint() {
      delete this.$store.getters.userSettings.helpHint;
      this.$store.getters.userSettings.filterHint = true;
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    },
    about() {
      this.dialog = () => import('@/views/login/LoginAbout');
    },
    versionSummary() {
      this.dialog = () => import('@/views/login/VersionSummary');
    },
    userPassword() {
      this.dialog = () => import('@/views/login/user/ConfigurationUserPassword');
    },
    showSwitch() {
      this.dialog = () => import('@/views/tools/ToolsCompanySwitch');
    },
    showEditFavourites() {
      this.dialog = () => import('@/views/tools/ToolsFavourites');
    },
    errorInfo() {
      if (this.error?.info?.type === 'Item')
        this.dialog = () => import('@/views/inventory/items/InventoryItemsTransactionError');
      else if (this.error?.info?.type === 'Product')
        this.dialog = () => import('@/views/inventory/products/InventoryProductsTransactionError');
      else if (this.error?.info?.type === 'Vessel')
        this.dialog = () => import('@/views/equipment/exciseVessel/ExciseVesselTransactionError');
      this.showError = false;
    },
    closeOpenGroups() {
      this.menuItems.forEach(item => {
        if (item.submenu)
          item.expanded = false;
      })
    },
    reload() {
      location.reload(true);
    },
    getFavourite(favouriteId) {
      for (const menu of this.favouritesPick) {
        const favourite = menu.menu.find(favourite => favourite.id === favouriteId);
        if (favourite)
          return favourite;
      }
    },
    to(favourite) {
      const parts = favourite.id.split(':');
      return {name: parts[0], query:{to:parts[1]}};
    },
    toggleLanguage() {
      this.$root.$i18n.locale = this.$root.$i18n.locale === 'fr' ? 'en' : 'fr';
      localStorage.setItem('locale', this.$root.$i18n.locale);
      location.reload(true);
    }
  },

  i18n: {
    messages: {
      en: {
        menu: {
          production: 'Production',
          mashing: 'Mashing',
          wineFermenting: 'Wine fermenting',
          distilling: 'Distilling',
          blending: 'Blending',
          bottling: 'Bottling',
          packing: 'Mixed-pack packing',
          assembly: 'Assembly',
          recipes: 'Recipes',
          mashBills: 'Mash bills',
          processes: 'Processes for distilling',
          formulas: 'Formulas for blending',
          equipment: 'Equipment',
          tanks: 'Tanks',
          fermenters: 'Fermenters',
          stills: 'Stills',
          otherEquipment: 'Other',
          inventory: 'Inventory',
          products: 'Products',
          bulkContainers: 'Bulk containers',
          casks: 'Casks',
          items: 'Items & services',
          bundles: 'Bundles',
          sales: 'Sales',
          salesOrders: 'Sales orders',
          shipments: 'Shipments',
          invoices: 'Invoices',
          customers: 'Customers',
          more: 'More',
          estimates: 'Estimates',
          returns: 'Returns',
          taxes: 'Taxes',
          terms: 'Terms',
          paymentMethods: 'Payment methods',
          salesReps: 'Sales representatives',
          zones: 'Shipment zones',
          purchasing: 'Purchasing',
          purchaseOrders: 'Purchase orders',
          inventoryReceipts: 'Inventory receipts',
          suppliers: 'Suppliers',
          alcohol: 'Alcohol',
          spirits: 'Spirits',
          wine: 'Wine',
          nonExcise: 'Non-excise',
          reports: 'Reports',
          bookmarks: 'Bookmarks',
          apps: 'Apps',
          settings: 'Settings'
        }
      },
      fr: {
        menu: {
          production: 'Production',
          mashing: 'Brassage',
          wineFermenting: 'Fermentation du vin',
          distilling: 'Distillation',
          blending: 'Mélange',
          bottling: 'Embouteillage',
          packing: 'Emballage en pack mixte',
          assembly: 'Assemblage',
          recipes: 'Recettes',
          mashBills: 'Écraser les factures',
          processes: 'Procédés de distillation',
          formulas: 'Formules à mélanger',
          equipment: 'Équipement',
          tanks: 'Réservoirs',
          fermenters: 'Fermenteurs',
          stills: 'Alambic',
          otherEquipment: 'Autres',
          inventory: 'Inventaire',
          products: 'Produits',
          bulkContainers: 'Vrac',
          casks: 'Fûts',
          items: 'Articles et services',
          bundles: 'Ensembles',
          sales: 'Ventes',
          salesOrders: 'Commandes',
          shipments: 'Expéditions',
          invoices: 'Factures',
          customers: 'Clients',
          more: 'Plus',
          estimates: 'Estimations',
          returns: 'Retour',
          taxes: 'Taxes',
          terms: 'Échéance de paiement',
          paymentMethods: 'Méthodes de paiement',
          salesReps: 'Représentants des ventes',
          zones: `Zones d'expédition`,
          purchasing: 'Achat',
          purchaseOrders: 'Bon de commande',
          inventoryReceipts: `Reçu d'inventaire`,
          suppliers: 'Fournisseurs',
          alcohol: 'Alcool',
          spirits: 'Spiritueux',
          wine: 'Vin',
          nonExcise: `Alcool sans droit d'accise`,
          reports: 'Rapports',
          bookmarks: 'Signets',
          apps: 'Applications',
          settings: 'Paramètres'
        }
      }
    }
  }
}
</script>

<style>
.cursor-pointer {
  cursor:pointer;
}
.purtrak-scrollable {
  overflow-y:scroll;
  height:calc(100vh - 158px);
}
.overflow-y {
  overflow-y:scroll;
}
.purtrak-table {
  margin-left:12px;
}
.purtrak-table table {
  padding-right:14px;
}
.total-row {
  font-weight: bold;
}
.total-row:hover {
  background-color: #fff !important;
}
.total-row-dark {
  font-weight: bold;
}
.no-hover:hover {
  background:inherit !important;
}
.total-row-dark:hover {
  background-color: #1e1e1e !important;
}
.table-footer-column {
  border-top:1px solid #ddd;
}

.selected-list-item {
  background-color: #F5F5F5;
}

.list-column {
  border-bottom:none !important;
}
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
.tour {
  text-indent:0;
  letter-spacing:0;
}
.tour-arrow {
  margin-top: 40px;
  contain: initial;
  overflow: visible;
}
.tour-arrow::before {
  position: absolute;
  content: "";
  top: 0;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #9C27B0;
}
.tour-arrow-left::before {
  left: 15px;
}
.tour-arrow-right::before {
  right: 15px;
}
.v-tabs.full-height-tab  .v-window-item {
  height: calc(100vh - 206px);
  overflow-y: auto;
}
.row + .row {
  margin-top:0px;
}
.no-sort .v-data-table-header-mobile {
  display:none
}

.v-data-table__expanded__content {
  box-shadow: none !important;
}
</style>
